import { DeepIcon, PiyushIcon, RiteshIcon } from "components";

const FounderSection = () => {
  return (
    <div className="flex flex-col w-full h-full justify-center items-center gap-10 p-4 md:py-20 bg-[#222]">
      <div className="flex flex-col w-full max-w-[988px] justify-start items-center gap-10 p:50">
        {/* Founder 1 */}
        <div className="w-[768px] flex flex-col justify-start items-center gap-2">
          <div className="self-stretch text-center justify-start text-gray-100 text-4xl font-medium font-['Inter'] tracking-tight">
            The People Behind the Mission
          </div>
          <div className="self-stretch text-center justify-start text-gray-500 text-base font-medium font-['Inter'] leading-6 tracking-tight">
            Founders with a passion for finance, technology, and advisor
            success.
          </div>
        </div>
        <div className="flex justify-center items-center gap-8 md:gap-10 md:grayscale hover:grayscale-0 transition-all duration-300">
          <RiteshIcon
            className="w-[580px] h-auto rounded-lg object-cover"
            title="Ritesh Lahoti"
          />
          <div className="flex flex-col gap-4 text-left">
            <h3 className="text-white text-2xl sm:text-3xl font-medium font-['Inter']">
              Ritesh Lahoti — Founder & CEO
            </h3>
            <p className="text-gray-300 text-sm sm:text-base font-medium font-['Inter'] leading-7">
              An NMIMS alum with over a decade of experience in startups and
              strategy, Ritesh brings deep operational expertise and a passion
              for building impactful businesses. He leads Gridkey with a vision
              to simplify and scale financial innovation.
            </p>
          </div>
        </div>

        <hr className="w-full border-gray-900" />

        {/* Founder 2 */}
        <div className="flex flex-col md:flex-row-reverse justify-start items-center gap-8 md:gap-10 md:grayscale hover:grayscale-0 transition-all duration-300">
          <PiyushIcon
            className="w-[580px] h-auto rounded-lg object-cover"
            title="Piyush Sarawagi"
          />
          <div className="flex flex-col items-center md:items-end gap-4 text-center md:text-right  md:grayscale hover:grayscale-0 transition-all duration-300">
            <h3 className="text-white text-2xl sm:text-3xl font-medium font-['Inter']">
              Piyush Sarawagi — Founder & COO
            </h3>
            <p className="text-gray-300 text-sm sm:text-base font-medium font-['Inter'] leading-7">
              An NMIMS alum with over a decade of experience in startups and
              strategy, Ritesh brings deep operational expertise and a passion
              for building impactful businesses. He leads Gridkey with a vision
              to simplify and scale financial innovation.
            </p>
          </div>
        </div>

        <hr className="w-full border-gray-900" />

        {/* Founder 3 */}
        <div className="flex flex-col md:flex-row justify-start items-center gap-8 md:gap-10 md:grayscale hover:grayscale-0 transition-all duration-300">
          <DeepIcon
            className="w-[580px] h-auto rounded-lg object-cover"
            title="Deep Jethloja"
          />
          <div className="flex flex-col items-center md:items-start gap-4 text-center md:text-left">
            <h3 className="text-white text-2xl sm:text-3xl font-medium font-['Inter']">
              Deep Jethloja — Co-founder & CTO
            </h3>
            <p className="text-gray-300 text-sm sm:text-base font-medium font-['Inter'] leading-7">
              An IIT Roorkee alum and former engineer at PhonePe, Deep combines
              technical depth with a product-first mindset. With 4+ years in
              technology, he leads the development of Gridkey’s intelligent
              financial infrastructure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderSection;
